import { GlowModal, GlowSkeleton } from '@headless-workspace/glow-ds';

export const QuickViewProductMenuSkeleton = () => {
    return (
        <GlowModal.Container
            fallback={<GlowSkeleton containerClassName={'w-full'} height={'1.875rem'} />}
            onClick={undefined}
        >
            <GlowModal.Content>
                <GlowSkeleton
                    itemClassName={'!w-[16.4375rem] !h-[16.4375rem] tablet:!w-[21.4375rem] tablet:!h-[21.4375rem]'}
                    containerClassName={'items-center'}
                />

                <div className={'flex flex-col gap-0.5'}>
                    <GlowSkeleton height={'1.25rem'} containerClassName={'w-full'} />
                    <GlowSkeleton width={'6.938rem'} height={'1.25rem'} />
                    <GlowSkeleton width={'6.938rem'} height={'1.25rem'} />
                </div>
                <GlowSkeleton height={'1.25rem'} />
                <div className={'flex flex-col gap-0.5'}>
                    <GlowSkeleton height={'3.75rem'} containerClassName={'w-full'} />
                    <GlowSkeleton height={'3.75rem'} containerClassName={'w-full'} />
                    <GlowSkeleton height={'3.75rem'} containerClassName={'w-full'} />
                    <GlowSkeleton height={'3.75rem'} containerClassName={'w-full'} />
                    <GlowSkeleton height={'3.75rem'} containerClassName={'w-full'} />
                    <GlowSkeleton height={'3.75rem'} containerClassName={'w-full'} />
                </div>
                <GlowSkeleton height={'7.15rem'} containerClassName={'w-full'} />
            </GlowModal.Content>
            <GlowModal.Footer>
                <GlowSkeleton height={'3rem'} containerClassName={'w-full'} />
                <GlowSkeleton height={'3rem'} containerClassName={'w-full'} />
            </GlowModal.Footer>
        </GlowModal.Container>
    );
};
